export default "__VITE_ASSET__D_Rycw3O__"